export const Copy = () => (
  <g>
    <path
      d='M14.3684 6H8.05263C7.47368 6 7 6.49091 7 7.09091V14.7273H8.05263V7.09091H14.3684V6ZM15.9474 8.18182H10.1579C9.57895 8.18182 9.10526 8.67273 9.10526 9.27273V16.9091C9.10526 17.5091 9.57895 18 10.1579 18H15.9474C16.5263 18 17 17.5091 17 16.9091V9.27273C17 8.67273 16.5263 8.18182 15.9474 8.18182ZM15.9474 16.9091H10.1579V9.27273H15.9474V16.9091Z'
      fill='currentColor'
    />
  </g>
)
